import { createEntityState } from 'modules/redux-store';

const INITIAL_STATE = createEntityState<Unit>();

export const unitReducer = (
  state = INITIAL_STATE,
  action:
    | ActionUnion<EntityActions<'units', Unit>>
    | Action<'authentication/LOGOUT'>,
): EntityState<Unit> => {
  switch (action.type) {
    case 'units/LOADING':
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case 'units/ON_SNAPSHOT_UPDATE':
      return {
        ...state,
        isLoading: false,
        documents: action.payload.documents,
      };
    case 'units/ON_SNAPSHOT_ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case 'authentication/LOGOUT':
      return INITIAL_STATE;
    default:
      return state || INITIAL_STATE;
  }
};
